exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n/* Add consistent row styles with maximum width for neat appearance */\n.subscription-container[data-v-04079059] {\n    width: 100%;\n    max-width: 800px;\n    margin: 0 auto;\n}\n.subscription-row[data-v-04079059] {\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    gap: 10px;\n    margin-bottom: 10px;\n}\n.subscription-row select[data-v-04079059],\n.subscription-row button[data-v-04079059],\n.subscription-row .date-picker[data-v-04079059] {\n    max-width: 300px;\n}\n", ""]);

// exports
